"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var jsx_runtime_1 = require("react/jsx-runtime");

var SupportTicketLink_1 = __importDefault(require("./SupportTicketLink"));

var SourceFileLink_1 = __importDefault(require("./SourceFileLink"));

var PowerBiNoContentMessage = function (_a) {
  var item = _a.item,
      isPwcUser = _a.isPwcUser,
      errorCode = _a.errorCode;
  var tab = item.tab;

  var getPwcUserMessage = function () {
    return (0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, {
      children: [(0, jsx_runtime_1.jsx)("div", __assign({
        className: "content-section"
      }, {
        children: (0, jsx_runtime_1.jsxs)("div", {
          children: ["The Power BI tab may have been renamed or deleted. Please check the", ' ', tab, " tab in", (0, jsx_runtime_1.jsx)(SourceFileLink_1.default, {
            item: item
          }, void 0), "."]
        }, void 0)
      }), void 0), (0, jsx_runtime_1.jsxs)("div", __assign({
        className: "content-section"
      }, {
        children: ["If the issue continues, please ", (0, jsx_runtime_1.jsx)(SupportTicketLink_1.default, {}, void 0), " for this issue", errorCode && "and make sure to include the error code " + errorCode, "."]
      }), void 0)]
    }, void 0);
  };

  var getClientMessage = function () {
    return (0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, {
      children: [(0, jsx_runtime_1.jsx)("div", __assign({
        className: "content-section"
      }, {
        children: "The Power BI tab may have been renamed or deleted"
      }), void 0), (0, jsx_runtime_1.jsxs)("div", __assign({
        className: "content-section"
      }, {
        children: ["Please ", (0, jsx_runtime_1.jsx)(SupportTicketLink_1.default, {}, void 0), " for this issue", errorCode && "and make sure to include the error code " + errorCode, "."]
      }), void 0)]
    }, void 0);
  };

  return (0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, {
    children: [isPwcUser && getPwcUserMessage(), !isPwcUser && getClientMessage(0)]
  }, void 0);
};

exports.default = PowerBiNoContentMessage;